'use es6';

export const get = spec => {
  return spec.defaultParams || {};
};